module.exports = {
  applicationInfo:{
    appName: "eduFlex & BIM",
    devOrgName: "DataCo Systems Limited",
    devOrgLink: "http://www.bim.gov.bd/"
  },
  applicationSettings:{
    developmentBaseURL : "https://api.eduflex.bim.gov.bd/api/",//"https://api-new.sustainability.com.bd/api/",//"http://localhost:3334/api/",
    productionBaseURL : "https://api.eduflex.bim.gov.bd/api/",//"http://localhost:3334/api/",//"https://bim-api.braintechsolution.com/api/",//"https://api-new.sustainability.com.bd/api/",//"http://localhost:3334/api/",
    session_name : "Supplychain",
    webBaseUrl : "https://eduflex.bim.gov.bd",
    secretKey : "eduFlex@Shik"
  },
  zoomSettings:{
    baseURL : "http://localhost:3001/",
  }
}


